import React from 'react';
import { Loadable } from 'shared/hocs/loadable';
import { Loader } from 'shared/ui/loader';


export const SurveyLoyaltyLoadable = Loadable({
    loader: (): any => import('./SurveyLoyalty').then((res) => res.SurveyLoyalty),
    loading: <Loader/>,
});
